import { Button, Grid, Typography } from '@mui/material';
import React from 'react';
import LeaveDashboard from './LeaveDashboard';
import OnLeave from './OnLeave';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';

interface Props {
  userRole: string | null;
}

const LeaveManagementHrView: React.FC<Props> = (prop) => {
  const navigate = useNavigate();
  const employeeType = useSelector((state: RootStateType) => state.leaveManagementReducer.userDetails.employmentType);

  return (
    <div>
      <Grid container sx={{ mt: 2, mb: 2 }} justifyContent="space-between">
        <Grid item>
          <Typography
            style={{
              marginLeft: '0px',
              fontWeight: '700',
              fontSize: '16px',
              fontFamily:
                'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
            }}
          >
            <span
              style={{
                cursor: 'pointer'
              }}
              onClick={() => {
                navigate(`/leave-management`);
              }}
            >
              Leave Management
            </span>
          </Typography>
          <Typography variant="subtitle2"></Typography>
        </Grid>
        <Grid item>
          <Button
            sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/apply-leave`);
            }}
          >
            Apply Leave
          </Button>
          {/* <Button
            sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/apply-wfh`);
            }}
          >
            Apply Work From Home
          </Button> */}
          {employeeType === 'Permanent' && (
            <Button
              sx={{
                mr: 2,
                mt: { xs: 2, md: 0 },
                fontSize: '11px',
                fontWeight: 'normal'
              }}
              variant="contained"
              style={{ height: '1.75rem' }}
              onClick={(e) => {
                navigate(`/leave-management/apply-lieu-leave`);
              }}
            >
              Lieu Leave Eligibility
            </Button>
          )}
          <Button
            sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/RM-pending-requests`);
            }}
          >
            PM/RM Pending Requests
          </Button>
          <Button
            sx={{
              mr: 2,
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/employee-leaves`);
            }}
          >
            Employee Leaves
          </Button>
          <Button
            sx={{
              mt: { xs: 2, md: 0 },
              fontSize: '11px',
              fontWeight: 'normal'
            }}
            variant="contained"
            style={{ height: '1.75rem' }}
            onClick={(e) => {
              navigate(`/leave-management/my-leave-history/id`);
            }}
          >
            My Leave History
          </Button>
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 1, mb: 1, px: 0, mx: 0, pl: 0 }}>
        <Grid xs={9}>
          <LeaveDashboard onView={(data: any) => {}} />
        </Grid>
        <Grid item xs={3} style={{ paddingLeft: '1rem' }}>
          <OnLeave userRole={prop?.userRole} />
        </Grid>
      </Grid>
    </div>
  );
};

export default LeaveManagementHrView;
